"use client"

import { MemberEntity } from "@/app/entities/UserEntity"
import fetchInterceptorInClient from "@/components/fetcher/fetchInterceptorInClient"
import {
  resultPostprocessing2,
} from "@/components/fetcher/fetchInterceptor"

const ROOT = process.env.NEXT_PUBLIC_ROOT

export type MemberCheckResponse = MemberEntity & { imageUrl: string }

const fetchClientMemberCheck = ({
  dgtId,
  xEncParam,
  xEncTime,
}: {
  dgtId?: string
  xEncParam?: string
  xEncTime?: string
}) => {
  return fetchInterceptorInClient(
    {
      method: "post",
      headers: {
        ...(xEncParam &&
          xEncTime && {
            "x-enc-param": xEncParam,
            "x-enc-time": xEncTime,
          }),
        ...(dgtId !== undefined && { "x-enc-dgt-id": dgtId }),
      },
    },
    ROOT,
  )(() => `/api/bff/account/member-check`).then(
    resultPostprocessing2<MemberCheckResponse>,
  )
}

export default fetchClientMemberCheck
